import React, { useEffect, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const UploadBadge = () => {
  const [currentNotify, setNotify] = useState(null);
  const { getSchoolProfile } = useConfig();
  const [loading, setLoading] = useState(false);
  const [fileSource, setFileSource] = useState('');
  const [actualFile, setActualFile] = useState(null);

  useEffect(() => {
    if (currentNotify) {
      const timer = setTimeout(() => setNotify(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [currentNotify]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileSource(event.target.value);

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      setActualFile(e.target.result); // base64-encoded string
    };
  };

  const handleSave = async (event) => {
    event.preventDefault();
    if (!actualFile) {
      setNotify(<Notification type="danger" message="Please select a file before uploading." />);
      return;
    }

    setLoading(true);

    const data = {
      badge: {file: actualFile}, // base64 encoded image
    };

    const server_response = await ajaxConfig.uploadBadge(data);
    setLoading(false);
    if (server_response.status === 'OK') {
      setNotify(<Notification type="success" message={server_response.message} />);
      getSchoolProfile(true);
    } else {
      setNotify(<Notification type="danger" message={server_response.message} />);
    }
  };

  return (
    <div className="card-body">
      <CallOut title="Change Badge" description="Upload a new school badge." />
      {currentNotify}
      <form className="form-horizontal" onSubmit={handleSave}>
        <TextInput
          type="file"
          label="School Badge"
          placeholder="Select Badge"
          leftIcon="fa fa-info"
          value={fileSource}
          name="badge"
          onChange={handleFileChange}
          wrap
          accept="image/*"
          required
        />

        <div className="text-right">
          {!loading && <button type="submit" className="btn btn-lg btn-primary">Upload Badge</button>}
          {loading && <ActivityLoader />}
        </div>
      </form>
    </div>
  );
};

export default UploadBadge;
